<template>
    <mvtShifter ref="scrollerCat" class="dpp-photo-nav" v-if="getCategories && getCategories.length">
        <figure :key="item.key"  v-for="item in getCategories" class="dpp-photo-nav-item" @click="changePhotoCate(item.cateIndex, item.index)" :data-index="item.i" :data-cateIndex="item.cateIndex" :data-photoIndex="item.index">
            <img :alt="`${item.tag ? item.tag+' -' : ''} ${dpp.geo.formatAddress} photo ${item.index+1}${item.count ? ' of '+item.count: ''}`" :src="item.path + item._p" loading="lazy"/>
            <figcaption v-if="item.tag">{{item.tag}}</figcaption>
        </figure>
        <button type="button" v-if="dpp.threeDTourLink" @click="pop3d(dpp.threeDTourLink)" class="dpp-photo-nav-item button"> <i class="icon-virtual-3D"></i><span>3D</span> </button>
        <button type="button" v-if="dpp.videoTourLink" @click="pop3d(dpp.videoTourLink)" class="dpp-photo-nav-item button"> <i class="icon-video"></i><span>Video</span> </button>
    </mvtShifter>
</template>
<script src="./dpp-photonav.js"></script>

<style lang="scss">
@use './dpp-photonav.scss' as *;
</style>